import React from 'react';
import PropTypes from 'prop-types';
import { DESACTIVE, CHANGE, REMIND, MODIFY } from '../constants';

const ButtonDefaultSection = ({
  labelDesactive,
  labelChange,
  labelRemind,
  labelModify,
  onToggle,
}) => (
  <div className="row padding-top-2">
    <div className="col-md-6 col-xs-12 pull-right">
      <div className="col-md-3 col-sm-6 col-xs-12">
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={() => onToggle(DESACTIVE)}
        >
          {labelDesactive}
        </button>
      </div>

      <div className="col-md-3 col-sm-6 col-xs-12">
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={() => onToggle(CHANGE)}
        >
          {labelChange}
        </button>
      </div>

      <div className="col-md-3 col-sm-6 col-xs-12">
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={() => onToggle(REMIND)}
        >
          {labelRemind}
        </button>
      </div>

      <div className="col-md-3 col-sm-6 col-xs-12">
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={() => onToggle(MODIFY)}
        >
          {labelModify}
        </button>
      </div>
    </div>
  </div>
);

ButtonDefaultSection.propTypes = {
  labelDesactive: PropTypes.string,
  labelChange: PropTypes.string,
  labelRemind: PropTypes.string,
  labelModify: PropTypes.string,
  onToggle: PropTypes.func,
};

export default ButtonDefaultSection;
